<template>
  <div class="custom-select component-select" :tabindex="tabindex" @blur="open = false" :class="disabled ? 'disabled' :''"  :disabled="disabled">
    <!-- {{options[0].descripcion}} -->
    <div class="selected" @click="open = !open" :class="{ open: open }"> 
      {{ selected }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div class="options" @click="selectOption(null,defaultValue,true)" v-if="validFirstOption">
      {{this.default}}</div>
      <!-- <div class="options" :class="option[label]===selected || null  ? 'optionSelected' : ''" -->
      <div class="options"
        :class="{'optionSelected' :option[label]===selected , 'optionDisabled': option.disabled}"
        v-for="(option, i) of options"
        :key="i"
        @click="selectOption(option[label],option[value],false)"
      >
        {{ option[label] }}
      </div> 
    </div>
  </div>
</template>
<script>
export default { 
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    isActiveMethodValidOpcion: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: String,
    value: String,
    defaultValue:{
      type:Number,
      default: null,
    },
    firstOptionShow:{
      type: Boolean,
      default: true
    },
    valueSelected:{
      type:String,
      default:null
    },
    disabled:{
      type:Boolean,
      default:false
    },
    toggleTextDefault:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
        ? this.options[0][this.label]
        : null,
      open: false,
      toggleInitialValue:null,
    };
  },
  watch:{
    options: function (val){
      this.validOpcionDefault();
    },
    defaultValue() {
      this.validOpcionDefault();
    },
    toggleTextDefault:function(){
      this.selected = this.default;
    }
  },
  computed:{
    validFirstOption(){
      return this.default  === null || this.firstOptionShow===false ? false : true
    }
  },
  mounted(){
    this.activeMethodValidOpcionDefault();
  },
  created () {
    window.addEventListener('scroll', this.orientacionDropdown);
  },
  destroyed () {
    window.removeEventListener('scroll', this.orientacionDropdown);
  },
  methods:{
    activeMethodValidOpcionDefault(){
      if(this.isActiveMethodValidOpcion===true){
        this.validOpcionDefault();
      }
      if(this.valueSelected != null){
        this.selected=this.valueSelected
      }
    },
    validOpcionDefault(){
      if(this.default==null){
        this.selected=this.options[this.defaultValue][this.label]
      }
    },
    selectOption(nameSelectOption,option,status){
      this.open = false;
      this.$emit('input', option);
      this.$emit('change');
      this.selected = status ? this.selected = this.default : this.selected = nameSelectOption;
     
    },
    orientacionDropdown(){
        let select = document.querySelector('.custom-select');
        let rect = select.getBoundingClientRect();
        let items = document.querySelector(".custom-select .items");
        if(rect.top > 300 && this.open){
          select.classList.add('dropdownTop')
          let rectHeight = items.offsetHeight;
          items.style.top = -rectHeight + 2 + 'px';
        } else {
          select.classList.remove('dropdownTop')
          items.style.top = null;
        }
      }
  }
};
</script>
<style >
.optionDisabled {
  color: grey;
  pointer-events: none;
  cursor: not-allowed;
}
</style>